/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { ReactElement } from 'react'
import styled from 'styled-components'
import { ConfigBar, EditorContainer } from 'plugin-assets/shared/widget/components/styled'
import PreviewAndData from 'plugin-assets/shared/widget/multi-channel/editor/preview-and-data'
import Configs from './Configs'

export default function DefaultEditor(props: ChannelsWidgetEditorProps): ReactElement {
    return (
        <ThemedEditorContainer className="editor-container default-editor">
            <ConfigBar>
                <Configs
                    widgetConfig={props.data.jsonConfig}
                    type={props.selectedWidget.type}
                    tabs={props.tabs}
                    changeConfig={props.widgetConfigActions.changeConfig}
                    isEditor={true}
                />
            </ConfigBar>
            <PreviewAndData
                widgetConfigStore={props.widgetConfigStore}
                widgetConfigActions={props.widgetConfigActions}
                widgetDataStore={props.widgetDataStore}
                widgetDataActions={props.widgetDataActions}
                widget={props.data}
                renderPreview={props.renderPreview}
                isEmpty={false}
                isAssetSelected={true}
            />
        </ThemedEditorContainer>
    )
}

const ThemedEditorContainer = styled(EditorContainer)``
